// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getUser = createAsyncThunk(
	"globalUser/getUser",
	createApiCall(async (props, client) => {
		const setUser = props?.setUser || false;
		const response = await client.get(`/user`);
		return { result: response.data, setUser };
	})
);

// ############################################################
